const USER_INFO_TABS = [
  { key: 'basic-info', name: '基本信息', component: 'BasicInfo' },
  { key: 'account', name: '账号安全', component: 'Account' },
  { key: 'address', name: '收货地址', component: 'Address' },
  { key: 'parent-binding', name: '家长绑定', component: 'ParentBinding' },
]

function findUserInfoTabByQueryValue(tab) {
  if (!tab) return null
  return USER_INFO_TABS.find((item) => item.key === tab || item.component === tab) || null
}

function findUserInfoTabByComponent(component) {
  if (!component) return null
  return USER_INFO_TABS.find((item) => item.component === component) || null
}

function resolveUserInfoTabComponent(tab) {
  return (findUserInfoTabByQueryValue(tab) || USER_INFO_TABS[0]).component
}

function getUserInfoTabQueryValue(component) {
  return (findUserInfoTabByComponent(component) || USER_INFO_TABS[0]).key
}

module.exports = {
  USER_INFO_TABS,
  findUserInfoTabByQueryValue,
  findUserInfoTabByComponent,
  resolveUserInfoTabComponent,
  getUserInfoTabQueryValue,
}
